import React from 'react';
import Loadable from 'react-loadable';
import CoreException from './Error';
import { Loading } from '../components/Loading';

const getComponent = loader => ({
  loader,
  loading: props => {
    if (props.error) {
      return <CoreException desc={props.error.toString()} />;
    } else if (props.timedOut) {
      return (
        <CoreException
          desc="页面加载超时"
          onBtnClick={() => {
            window.location.reload();
          }}
          btnText="点我重试"
        />
      );
    } else if (props.pastDelay) {
      return <Loading />;
    }
    return null;
  }
});

const routes = [
  {
    path: '/h5_fe_shop/html/pay',
    title: '宝宝树商城',
    component: Loadable(
      getComponent(
        () => import(/* webpackChunkName: "DemoPay" */ 'pages/DemoPay/index.jsx')
      )
    )
  },
  {
    path: '/h5_fe_shop/html/',
    title: '宝宝树商城',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "DemoIndex" */ 'pages/Demo/pages/Index/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/develop/pregnancyweb/',
    title: '孕育web链接生成器',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "PregnancyWeb" */ 'pages/Develop/pages/PregnancyWeb/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/develop/pregnancyminiprogram/',
    title: '孕育跳转小程序H5',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "PregnancyMp" */ 'pages/Develop/pages/PregnancyMp/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/fosun/home/',
    title: '宝宝树精选',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "FosunHome" */ 'pages/Fosun/pages/Home/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/fosun/orderlist/',
    title: '我的订单',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "FosunOrderList" */ 'pages/Fosun/pages/Order/List/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/fosun/orderdetail/',
    title: '订单详情',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "FosunOrderDetail" */ 'pages/Fosun/pages/Order/Detail/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/fosun/ordercombinelist/',
    title: '相关订单',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "FosunOrderCombineList" */ 'pages/Fosun/pages/Order/List/order-combine-list.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/fosun/mine/',
    title: '我的',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "FosunMine" */ 'pages/Fosun/pages/Mine/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/fosun/aftersale/',
    title: '退款/售后',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "FosunAfterSaleList" */ 'pages/Fosun/pages/AfterSale/List/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/fosun/aftersale/apply/',
    title: '申请退款',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "FosunAfterSaleApply" */ 'pages/Fosun/pages/AfterSale/Apply/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/fosun/invoice/apply/',
    title: '申请发票',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "FosunInvoiceApply" */ 'pages/Fosun/pages/Invoice/Apply/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/fosun/invoice/detail/',
    title: '开票详情',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "FosunInvoiceDetail" */ 'pages/Fosun/pages/Invoice/Detail/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/fosun/invoice/rules/',
    title: '发票规则',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "FosunInvoiceRules" */ 'pages/Fosun/pages/Invoice/Rules/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/fosun/aftersale/selectservice/',
    title: '选择服务',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "FosunAfterSaleSelectService" */ 'pages/Fosun/pages/AfterSale/Apply/select-service.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/fosun/aftersale/detail/',
    title: '退款详情',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "FosunAfterSaleDetail" */ 'pages/Fosun/pages/AfterSale/Detail/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/fosun/arbitration/detail/',
    title: '售后详情',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "FosunArbitrationDetail" */ 'pages/Fosun/pages/AfterSale/Detail/arbitration-view.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/fosun/arbitration/apply/',
    title: '售后仲裁',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "FosunArbitrationApply" */ 'pages/Fosun/pages/AfterSale/Detail/arbitration/apply.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/fosun/arbitration/history/',
    title: '历史举证信息',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "FosunArbitrationHistory" */ 'pages/Fosun/pages/AfterSale/Detail/arbitration/history.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/fosun/aftersale/express/apply/',
    title: '上门取件',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "FosunAfterSaleExpressApply" */ 'pages/Fosun/pages/AfterSale/Express/Apply/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/fosun/aftersale/express/detail/',
    title: '取件详情',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "FosunAfterSaleExpressDetail" */ 'pages/Fosun/pages/AfterSale/Express/Detail/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/fosun/aftersale/express/self/',
    title: '填写快递单号',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "FosunAfterSaleExpressSelf" */ 'pages/Fosun/pages/AfterSale/Express/Self/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/fosun/aftersale/express/company/',
    title: '物流公司',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "FosunAfterSaleExpressCompany" */ 'pages/Fosun/pages/AfterSale/Express/Company/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/fosun/expressprotocol/',
    title: '顺丰退换包运费服务说明',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "FosunAfterSaleExpressProtocol" */ 'pages/Fosun/pages/AfterSale/Express/Protocol/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/fosun/paysuccess/',
    title: '支付成功页',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "FosunPaySuccess" */ 'pages/Fosun/pages/PaySuccess/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/fosun/productdetail/',
    title: '商品详情',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "FosunProductDetail" */ 'pages/Fosun/pages/ProductDetail/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/fosun/address/list/',
    title: '地址管理',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "FosunAddressList" */ 'pages/Fosun/pages/Address/List/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/fosun/address/detail/',
    title: '新增收货人',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "FosunAddressDetail" */ 'pages/Fosun/pages/Address/Detail/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/fosun/settlement/',
    title: '提交订单',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "FosunSettlement" */ 'pages/Fosun/pages/Settlement/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/fosun/haitaoprotocol/',
    title: '消费者告知书',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "FosunHaitaoProtocol" */ 'pages/Fosun/pages/HaitaoProtocol/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/fosun/login/',
    title: 'LoginDemo',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "FunsunLoginDemo" */ 'pages/Fosun/pages/Login/demo/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/fosun/comment/',
    title: '评价',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "FosunCommentApply" */ 'pages/Fosun/pages/Comment/Apply/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/fosun/comment/list',
    title: '我的评价',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "FosunCommentList" */ 'pages/Fosun/pages/Comment/List/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/fosun/comment/rule/cashback',
    title: '评价返现规则',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "FosunCommentCashBackRule" */ 'pages/Fosun/pages/Comment/CashBackRule/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/fosun/comment/rule/recommend',
    title: '发帖带货赚佣金',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "FosunCommentRecommendRule" */ 'pages/Fosun/pages/Comment/RecommendRule/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/minshengbank/home',
    title: '宝宝树&民生福利限时领',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "MinshengBankHome" */ 'pages/MinshengBank/pages/Home/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/fosun/comment/detail',
    title: '会员晒单',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "FosunCommentDetail" */ 'pages/Fosun/pages/Comment/Detail/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/fosun/videostickers',
    title: '新视频贴',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "VideoStickers" */ 'pages/Fosun/pages/VideoStickers/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/fosun/coupon/my',
    title: '我的优惠券',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "FosunCouponMy" */ 'pages/Fosun/pages/Coupon/My/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/minshengbank/rule',
    title: '专属权益活动',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "MinshengBankRule" */ 'pages/MinshengBank/pages/Rule/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/teBon/home',
    title: '宝宝树福利限时领',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "TeBonHome" */ 'pages/DeBangSecurities/Home/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/teBon/success',
    title: '宝宝树福利限时领',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "TeBonSuccess" */ 'pages/DeBangSecurities/Home/components/SuccessResult.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/teBon/auditing',
    title: '宝宝树福利限时领',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "TeBonAuditing" */ 'pages/DeBangSecurities/Home/components/NormalResult.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/teBon/fail',
    title: '宝宝树福利限时领',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "TeBonFail" */ 'pages/DeBangSecurities/FailResult/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/teBon/rule',
    title: '活动规则',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "TeBonRule" */ 'pages/DeBangSecurities/Rule/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/multipleCoupon/home',
    title: '优惠券',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "MultipleCouponHome" */ 'pages/MultipleCoupon/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/multipleCoupon/rule',
    title: '规则说明',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "MultipleCouponRule" */ 'pages/MultipleCoupon/rule.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/spike/home',
    title: '品牌秒杀',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "SpikeHome" */ 'pages/Spike/pages/Home/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/spike/rule',
    title: '规则说明',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "SpikeRule" */ 'pages/Spike/pages/Rule/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/neweruser/home',
    title: '新人专享',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "NewerUserHome" */ 'pages/NewerUser/pages/Home/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/neweruser/rule',
    title: '活动规则',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "NewerUserRule" */ 'pages/NewerUser/pages/Rule/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/cosmetic/parameters/',
    title: '产品参数',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "CosmeticParam" */ 'pages/CosmeticParam/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/recommendproduct',
    title: '宝妈们都爱买',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "RecommendProduct" */ 'pages/RecommendProduct/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/cms/page',
    title: '宝宝树商城',
    component: Loadable(
      getComponent(
        () => import(/* webpackChunkName: "CMSPage" */ 'pages/CMS/Pages/index.jsx')
      )
    )
  },
  {
    path: '/cms/:cmsCode',
    title: '宝宝树商城',
    component: Loadable(
      getComponent(
        () => import(/* webpackChunkName: "CMSPage" */ 'pages/CMS/Pages/index.jsx')
      )
    )
  },
  {
    path: '/h5_fe_shop/html/category/home',
    title: '类目页',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "CategoryHome" */ 'pages/Category/pages/Home/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/preferred/home',
    title: '宝树优选',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "PreferredHome" */ 'pages/Preferred/pages/Home/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/shopinglist/home',
    title: '购物清单',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "ShopingListHome" */ 'pages/ShopingList/pages/Home/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/shopinglist/sunbathing',
    title: '晒单',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "Sunbathing" */ 'pages/ShopingList/pages/Sunbathing/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/stroll/home',
    title: '逛一逛',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "StrollHome" */ 'pages/Stroll/pages/Home/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/shop/home',
    title: '店铺',
    component: Loadable(
      getComponent(
        () => import(/* webpackChunkName: "ShopHome" */ 'pages/Shop/Home/index.jsx')
      )
    )
  },
  {
    path: '/h5_fe_shop/html/shop/hotlist',
    title: '店铺',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "ShopHotlist" */ 'pages/Shop/HotList/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/rank/category',
    title: '排行榜',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "RankCategory" */ 'pages/Rank/pages/Category/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/rank/product',
    title: '商品排行榜',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "RankProduct" */ 'pages/Rank/pages/Product/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/draw/home',
    title: '树钻抽奖',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "DrawHome" */ 'pages/Draw/pages/Home/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/draw/threerules',
    title: '树钻规则',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "ThreeRules" */ 'pages/Draw/pages/ThreeRules/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/draw/activityrules',
    title: '规则介绍',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "ActivityRules" */ 'pages/Draw/pages/ActivityRules/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/CouponMyRule/rule',
    title: '规则说明',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "CouponMyRule" */ 'pages/Fosun/pages/Coupon/Rule/rule.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/classify',
    title: '分类页',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "ActivityRules" */ 'pages/Classify/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/reserve',
    title: 'Genius Key 分龄营养包新品预约',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "202311reserve" */ 'pages/202311/pages/reserve/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/reserveSuccess',
    title: '预约成功',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "202311reserveSuccess" */ 'pages/202311/pages/reserveSuccess/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/inquiry/quick',
    title: '快速问诊',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "InquiryQuick" */ 'pages/Inquiry/pages/Quick/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/inquiry/paysucc',
    title: '支付结果',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "InquiryQuickPaySucc" */ 'pages/Inquiry/pages/PaySucc/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/inquiry/normal',
    title: '常规问诊',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "InquiryNormal" */ 'pages/Inquiry/pages/Normal/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/inquiry/patient/detail',
    title: '完善资料',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "InquiryPatientDetail" */ 'pages/Inquiry/pages/Patient/patient-detail.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/inquiry/question_list',
    title: '问诊记录',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "InquiryQuestionList" */ 'pages/Inquiry/pages/QuestionList/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/inquiry/question_detail',
    title: '问诊详情',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "InquiryQuestionDetail" */ 'pages/Inquiry/pages/QuestionDetail/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/inquiry/index',
    title: '定向问诊',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "InquiryIndex" */ 'pages/Inquiry/pages/Index/index.jsx'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/inquiry/search',
    title: '搜索中间页',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "InquirySearchPage" */ 'pages/Inquiry/pages/SearchPage/index'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/fosun/savecard/agreement',
    title: '省钱卡服务协议',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "SavecardAgreement" */ 'pages/Fosun/pages/SaveCard/Agreement/index'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/fosun/savecard/rule',
    title: '省钱卡规则',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "SavecardRule" */ 'pages/Fosun/pages/SaveCard/Rules/index'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/fosun/platform/agreement',
    title: '美囤平台服务协议',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "PlatformAgreement" */ 'pages/Fosun/pages/Platform/Agreement/index'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/brandtryout/home',
    title: '品牌试用',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "BrandTryout" */ 'pages/BrandTryout/pages/Home/index'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/brandtryout/brand',
    title: '大牌试用',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "Brand" */ 'pages/BrandTryout/pages/Brand/index'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/brandtryout/free',
    title: '免费试用',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "BrandTryoutFree" */ 'pages/BrandTryout/pages/Free/index'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/brandtryout/free/claim',
    title: '免费申领',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "BrandTryoutFreeClaim" */ 'pages/BrandTryout/pages/Free/Claim/index'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/brandtryout/free/rules',
    title: '产品试用活动规则',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "BrandTryoutFreeRules" */ 'pages/BrandTryout/pages/Free/Rules/index'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/brandtryout/my',
    title: '我的试用',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "MyTryout" */ 'pages/BrandTryout/pages/My/index'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/brandtryout/nav-two-headers',
    title: '导航栏调试',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "BrandTryoutNavTwoHeaders" */ 'pages/BrandTryout/pages/NavTwoHeaders/index'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/brandtryout/apply',
    title: '我的申请',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "MyApply" */ 'pages/BrandTryout/pages/Apply/index'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/brandtryout/report/list',
    title: '试用体验报告',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "PublishReport" */ 'pages/BrandTryout/pages/Report/RList/index'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/brandtryout/report/try',
    title: '产品试用体验报告列表',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "PublishReport" */ 'pages/BrandTryout/pages/Report/Try/index'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/brandtryout/report/index',
    title: '产品试用体验报告',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "PublishReport" */ 'pages/BrandTryout/pages/Report/index'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/brandtryout/report/publish',
    title: '发布试用报告',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "PublishReport" */ 'pages/BrandTryout/pages/Report/Publish/index'
        )
      )
    )
  },
  {
    path: '/h5_fe_shop/html/brandtryout/report/detail',
    title: '试用体验报告详情',
    component: Loadable(
      getComponent(
        () => import(
          /* webpackChunkName: "ReportDetail" */ 'pages/BrandTryout/pages/Report/Detail/index'
        )
      )
    )
  },
  {
    path: '*',
    title: '抱歉，您访问的页面不存在！',
    component: require('core/Error/404').default
  }
];

const finalRouters = routes.map(route => {
  return {
    ...route,
    exact: true,
    strict: true // 为了使用serviceWorker，这里必须为true，因为如果使用/h5_fe_shop/html 这个路径sw不会生效
  };
});

export default finalRouters;
